import { SearchTerm } from "./SearchTerm";

const ModeSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "settingType.nameOriginal",
        translationKey: "name"
    },
];

export default ModeSearch;
